export const MAX_EMAILS = 5;

export const ADD_FORM_FIELDS = {
  EMAIL: {
    name: 'email',
    label: 'Add a recipient:',
    placeholder: 'Enter an email address',
    rules: [
      { required: true, message: 'Email is required' },
      { type: 'email', message: "Doesn't look like an email" },
    ],
  },
};

export const FORM_FIELDS = {
  EMAILS: {
    name: 'emails',
    rules: [{ min: 1, max: MAX_EMAILS }],
    serialize: (rules, data) => data[FORM_FIELDS.EMAILS.name] || [],
    deserialize: (rules, data) => ({
      [FORM_FIELDS.EMAILS.name]: data || [],
    }),
  },
};
